export const API_KEY_SKI = '948f00d6fba62696376f1e13';
export const API_KEY_MTB = '2abad9c7f3e25a39bb05c6d6';
